import React from 'react'
import { BsPlusCircle } from '@react-icons/all-files/bs/BsPlusCircle'

export default function PlusBtn() {
  return <BsPlusCircle className='btn-plus' />
}
